import { Auth } from "./Constants";
import { Redirect, Route } from "react-router-dom";
import LocalStorage from "../shared/localStorage";

const ProtectedRoute = ({ component: Component, ...restOfProps }) => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);
  return (
    <Route
      {...restOfProps}
      render={(props) => {
        if (parseLocalStorage?.isLoggedIn) {
          return (
            <Component
              {...props}
              setLoggedInInitials={restOfProps?.setLoggedInInitials}
            />
          );
        } else {
          return <Redirect to={Auth.LOGIN} />;
        }
      }}
    />
  );
};

export default ProtectedRoute;
